import React, { useState, useEffect } from "react"

import { Form, Row } from "react-bootstrap"

import InputField from './elements/input'
import SelectField from './elements/select'
import TextAreaField from './elements/textarea'
import CheckboxField from './elements/checkbox'
import ButtonField from './elements/button'
import HtmlBox from './elements/html'
import ReCaptchaBox from './elements/recaptcha'
import { postFormData } from "./api/Api"
import { Mail_Function } from "../common/utils"

function NewsletterForm(props) {

  const [validated, setValidated] = useState(false);
  const [showerror, setShowerror] = useState(false);
  const [showthankyou, setThankyou] = useState(false);

  const [formvalues, setFormvalues] = useState("");

  const [token, setToken] = useState("");

  const myRef = React.createRef();

  const recaptchaRef = React.createRef();

  //console.log("NameField",props.NameField);

  const fields = ([
      {
        element: "config",
        formname: "Newsletter",
        error_text: "Please enter valid email.",
        success_text: "Thank you for subscribing.",
        email_temp_user: "newsletter_user",
        email_temp_admin: "newsletter_admin",
        email_server_func: "newsletter",
        event_tracking: "newsletter",
        page_url: "/about/news-and-media/",
        email_subject_user: "Newsletter Subscription",
        email_subject_admin: "Newsletter Subscription"
      },
      {
        grpmd: "",
        label: "Email Address",
        placeholder: "",
        name: "email",
        type: "email",
        element: "input",
        required: true,
        patternchk:"[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$",
        class: "",
        grpcls: "d-flex align-items-center justify-content-between"
      },
      {
        name: "subscribe",
        type:"submit",
        element: "button",
        value: "Subscribe",
        class: "btn btn-white",
        customClass: "custom-button-wrapper"
      },
      {
        element: "captcha",
        class: "py-2",
        captchaRef: recaptchaRef
      },
    ]);

  const handlechange = event => {
    // remove initial empty spaces
    event.target.value = event.target.value.trimStart()
  }

  useEffect(() => {
    if (token !== '') {

 const processFromData = async () => {

      let formData = new FormData();

      formData.append('data', JSON.stringify(formvalues));

      postFormData(formData).then(async apiRes => {

        window.grecaptcha.reset();
        await Mail_Function(formvalues);

      });

      formvalues['g-recaptcha-response'] = token;

      // tracking event
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'formSubmit',
        'formType': 'form-'+fields[0].event_tracking,
        'formId': 'form-'+fields[0].event_tracking,
        'formName': fields[0].formname,
        'formLabel': fields[0].formname
      });

      setShowerror(false);
      setThankyou(true);
      myRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' })

      }
      processFromData();

    }
  }, [token]);

  const handleonVerify = token => {
    console.log("captcha verified");
    //setToken(token);
  };

  const handleSubmit = event => {

    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setShowerror(true);
      setValidated(true);
      setThankyou(false);
      myRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
    }
    else {

      event.preventDefault();

      const formsdata = (event.target);
      const json = {}
      Object.keys(formsdata).map(key => (
        json[formsdata[key].name] = (formsdata[key].checked) ? 'yes' : formsdata[key].value
      ))
      
      json['name'] = json.email;
      json['email_temp_user'] = fields[0].email_temp_user;
      json['email_temp_admin'] = fields[0].email_temp_admin;
      json['formname'] = fields[0].formname;
      json['g-recaptcha-response'] = token;
      json['email_subject_user'] = fields[0].email_subject_user;
      json['email_subject_admin'] = fields[0].email_subject_admin;

      setFormvalues(json);
      setToken("test");

      recaptchaRef.current.execute();

      setValidated(false);

      // reset form
      const form = event.target
      form.reset();
      
    }
  };

  return (
    <>

    {/* {showerror && <div className="alert alert-danger">
      {fields[0].error_text}
    </div>} */}

    {/* {showthankyou && <div className="alert alert-success">
      {fields[0].success_text}
    </div>} */}

    <div ref={myRef} />
      <Form className="footer-form d-md-flex" name={fields[0].formname} action="/thank-you/" method="post" noValidate validated={validated} onSubmit={handleSubmit}>
        <input type="hidden" name="form_name" value={fields[0].formname} />
        <input type="hidden" name="form_type" value={fields[0].form_type} />
        <input type="hidden" name="to_email_id" value={process.env.GATSBY_MAIL_NEWSLETTER} />
        <input type="hidden" name="bot-field" />
        <input type="hidden" name="admin_email" value={"Yes"} />

        <div className="form-wrapper">
        {showerror && <div className="error_msg">{fields[0].error_text}</div>}
        {showthankyou && <div className="error_msg success">{fields[0].success_text}</div>}
        
        {fields.map((field, index) => {
            if ( "input" === field.element ) {
              return (
                <div className="form-field custom-text-field-wrapper">
                  <InputField
                    name={field.name}
                    grpmd={field.grpmd}
                    ref={field.ref}
                    label={field.label}
                    type={field.type}
                    fieldClass={field.class}
                    placeholder={field.placeholder}
                    labelClass={field.labelClass}
                    required={field.required}
                    key={`${field.element}~${index}`}
                    pattern={field.patternchk}
                    handlechange={handlechange}
                    grpcls={field.grpcls}
                  />
                  
                </div>
              );
            }
            if ("captcha" === field.element) {
              return (
                <ReCaptchaBox
                  fieldClass={field.class}
                  captRef={field.captchaRef}
                  key={`${field.element}~${index}`}
                  handleonVerify={handleonVerify}
                />
              );
            }
            if ("button" === field.element) {
              return (
                <div className="button-container">
                  <ButtonField
                    name={field.name}
                    fieldClass={field.class}
                    type={field.type}
                    value={field.value}
                    key={`${field.element}~${index}`}
                    customClass={field.customClass}
                  />
                </div>
              );
            }
          })
        }
        </div>

      </Form>
    </>
  );
}


const NewsletterFormPage = (props) => (
  <NewsletterForm {...props} />
)

export default NewsletterFormPage
